import * as yup from 'yup';
import { CalendrierScolaire } from '../entities';

export const schemaCalendrierScolaire = yup.object<Partial<CalendrierScolaire>>({
    annnee_scolaire: yup.string().nullable(),
    fk_centre_service_scolaire: yup.number().nullable(),
    notes: yup.string().nullable(),
}) as yup.ObjectSchema<Partial<CalendrierScolaire>>;